import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthContext } from '@/contexts/AuthContext';
import { PageLoader } from '@/components/Common/PageLoader/PageLoader';
import { TermsOfServiceDialog } from '@/components/Authentication/TermsOfServiceDialog';
import { getCookie, ONE_YEAR_SECONDS, setCookie } from '@/services/cookiesService';

export const IDP_INITIATED_REDIRECT_PATH = 'idp_initiated_redirect_path';

const TERMS_OF_SERVICE_ACCEPTED_COOKIE = 'weavy_tos_accepted';

const isTermsOfServiceAccepted = () => getCookie(TERMS_OF_SERVICE_ACCEPTED_COOKIE) === 'true';
const setTermsOfServiceAccepted = () =>
  setCookie(TERMS_OF_SERVICE_ACCEPTED_COOKIE, 'true', { maxAge: ONE_YEAR_SECONDS });

export function IdpInitiatedSignInPage() {
  const { initiateRedirectSignIn, signOut } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const [showTermsOfService, setShowTermsOfService] = useState(false);

  const proceedToOAuth = () => signOut().then(() => initiateRedirectSignIn('figma', '/signin'));

  useEffect(() => {
    const redirectPath = searchParams.get('redirect_path') ?? '/';
    if (redirectPath) {
      sessionStorage.setItem(IDP_INITIATED_REDIRECT_PATH, redirectPath);
    } else {
      sessionStorage.removeItem(IDP_INITIATED_REDIRECT_PATH);
    }

    if (isTermsOfServiceAccepted()) {
      void proceedToOAuth();
    } else {
      setShowTermsOfService(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initiateRedirectSignIn, searchParams, signOut]);

  const handleTermsOfServiceAccept = () => {
    setTermsOfServiceAccepted();
    setShowTermsOfService(false);
    void proceedToOAuth();
  };

  if (showTermsOfService) {
    return <TermsOfServiceDialog onAccept={handleTermsOfServiceAccept} />;
  }

  return <PageLoader />;
}
